//Global
import * as React from 'react';

//MUI
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
//icons
import Check from '@mui/icons-material/Check';
//Custom
import API_CONSTANTS from '../resources/constants/api.json';
import ColorModeSelect from '../shared-theme/ColorModeSelect';

export default function TopBar(props) {
    const useState = React.useState;
    const useEffect = React.useEffect;
    console.log('TopBar Props', props)
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false)

    const generateListItems = () => {
        console.log('props', props)        
        return (
            <MenuList dense>
                {
                props.menuItems.map(item => {
                    return (
                        <MenuItem key={item+"_key"} onClick={()=>{
                            handleClose();
                            props.setSelectedPage(item)}
                            }>    
                            <ListItemIcon key={item+"_lii"}>
                                {item.toLowerCase() === props.parent.toLowerCase() ? 
                                <Check key={item+"_chk"} /> : null
                                }
                            </ListItemIcon>
                            <ListItemText key={item+"_lit"}>{item}</ListItemText>
                        </MenuItem>
                    )
                })
                
                }
            </MenuList>
        )
    }

    const handleClick = (event) => {
        if (!anchorEl){
            setAnchorEl(event.currentTarget);
            setOpen(true)
        }
    };
    const handleClose = () => {
        console.log('handleClose')
        setOpen(false)
        setAnchorEl(null);
        
    };
    console.log('open',open)
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
            <Toolbar>
                <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={(ev)=>{handleClick(ev)}}
                >
                    <MenuIcon />
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                        'aria-labelledby': 'basic-button',
                        }}
                        >
                        {generateListItems()}
                    </Menu>
                </IconButton>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    VantagePoint Properties Portal
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box>
                        <Typography variant="h8" component="div" align="right" sx={{ flexGrow: 1 }}>
                            Logged in as: {props.userName}
                        </Typography>
                        <Typography variant="h8" component="div" align="right" sx={{ flexGrow: 1 }}>
                            Current run date: {props.runDate}
                        </Typography>
                    </Box>
                    <ColorModeSelect />
                </Box>
            </Toolbar>
            </AppBar>
        </Box>
    );
}